<template>
	<div>options</div>
</template>

<script>

export default {
	name: 'pageoptions'
}
</script>
